/** Statsig gate for `/tenants*` routes (shared with main.jsx). */
export const TENANTS_FEATURE_GATE = 'cc-5324_tenant_and_statsig_automation'

/**
 * Statsig gate that controls the tenant-level "Admin Settings" section
 * (Organization Management + Feature Management). Each individual tenant admin
 * sees these pages once the gate is enabled for them — no org allowlist needed
 * because the pages are scoped to the admin's own tenant.
 */
export const ADMIN_SETTINGS_FEATURE_GATE =
  'fe-707-apply-branding-on-organization-and-features-management-tenant-on'
/** Org feature + user-access-group key; must match `VITE_FEATURES_V2` leaf. */
export const TENANT_DASHBOARD_FEATURE_KEY = 'tenant_dashboard'
